import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, BrainCircuitIcon, MonitorPlayIcon, PhoneCallIcon, CalculatorIcon, ArrowRightIcon } from 'lucide-react';
export function ValueStackLP4() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = [{
    icon: BookOpenIcon,
    title: 'EL MINI-CURSO "AI WEB CLOSER"',
    value: '$197',
    description: '4 módulos de acción rápida. Cada módulo tiene menos de 20 minutos. Puedes terminar el curso en una tarde y empezar a contactar clientes esa misma noche.'
  }, {
    icon: BrainCircuitIcon,
    title: 'EL CEREBRO DE IA "LOCAL SCOUT"',
    value: '$197',
    description: 'La IA personalizada que encuentra negocios locales sin sitio web o con sitios obsoletos. Solo le dices la ciudad y el tipo de negocio. Ella hace el trabajo de investigación por ti.'
  }, {
    icon: MonitorPlayIcon,
    title: 'EL CEREBRO DE IA "WEB BUILDER"',
    value: '$197',
    description: 'La IA que construye el sitio web del cliente en minutos. Le das la información del negocio y ella genera una página profesional lista para presentar.'
  }, {
    icon: PhoneCallIcon,
    title: 'EL GUION DE CIERRE "AI WEB CLOSER"',
    value: '$197',
    description: 'El guion exacto para llamar o escribirle al dueño del negocio y cerrar la venta. Incluye las respuestas exactas a las 5 objeciones más comunes.'
  }, {
    icon: CalculatorIcon,
    title: 'LA CALCULADORA DE PRECIOS',
    value: '$27',
    description: 'Sabe exactamente cuánto cobrar según el tipo de negocio, la ciudad y los servicios incluidos para que nunca cobres de menos.'
  }];
  return <section ref={ref} className="w-full py-20 px-4 bg-navy-light" data-id="element-698">
      <div className="max-w-4xl mx-auto" data-id="element-699">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-700">
          <h2 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-701">
            Todo lo que Obtienes Hoy por Solo{' '}
            <span className="text-gold" data-id="element-702">$27</span>:
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-703">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -50
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -50
          }} transition={{
            duration: 0.6,
            delay: 0.2 + index * 0.1
          }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 hover:border-gold/40 transition-colors shadow-lg" data-id="element-704">
                <div className="flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-6" data-id="element-705">
                  <div className="flex-shrink-0 w-14 h-14 bg-gold/10 border border-gold/30 rounded-xl flex items-center justify-center" data-id="element-706">
                    <Icon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-707" />
                  </div>

                  <div className="flex-1" data-id="element-708">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-2" data-id="element-709">
                      <h3 className="font-heading font-black text-lg md:text-xl text-white" data-id="element-710">
                        {item.title}
                      </h3>
                      <span className="font-heading font-bold text-sm md:text-base text-gold bg-gold/10 px-3 py-1 rounded-full w-fit" data-id="element-711">
                        Valor: {item.value}
                      </span>
                    </div>
                    <p className="font-body text-base text-gray-300 leading-relaxed" data-id="element-712">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="bg-gradient-to-br from-navy-dark to-navy border-2 border-gold rounded-2xl p-8 text-center shadow-2xl relative overflow-hidden" data-id="element-713">
          {/* Shimmer effect */}
          <motion.div animate={{
          x: ['-100%', '100%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute inset-0 w-1/2 bg-gradient-to-r from-transparent via-gold/10 to-transparent pointer-events-none" data-id="element-714" />

          <div className="relative z-10" data-id="element-715">
            <p className="font-heading font-bold text-2xl md:text-3xl text-gray-400 mb-2" data-id="element-716">
              VALOR TOTAL:{' '}
              <span className="line-through decoration-red-500/50" data-id="element-717">$835</span>
            </p>
            <p className="font-heading font-black text-4xl md:text-6xl text-gold mb-8 drop-shadow-lg" data-id="element-718">
              TÚ PAGAS HOY: $27
            </p>

            <p className="font-body text-sm text-gray-400 mb-8 italic max-w-2xl mx-auto" data-id="element-719">
              (Nota: En la llamada te explicaremos cómo acceder al software de
              IA necesario para operar el sistema).
            </p>

            <motion.a href="/checkout-2" onClick={() => {
            if ((window as any).fbq) (window as any).fbq('track', 'AddToCart', {
              content_name: 'AI Web Closer Course',
              content_type: 'product',
              value: 27,
              currency: 'USD'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex group bg-gold hover:bg-gold-light text-navy font-heading font-black text-xl px-8 py-5 rounded-xl shadow-xl shadow-gold/20 transition-all duration-300 items-center justify-center gap-3 w-full sm:w-auto" data-id="element-720">
              QUIERO ACCESO POR $27
              <ArrowRightIcon className="h-6 w-6 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-721" />
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}